// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deleteIcon[data-v-f1f952fc]{font-size:18px;position:absolute;right:15px;top:15px;cursor:pointer;z-index:1}[data-v-f1f952fc] .el-dialog__header{border-bottom:1px solid #ebebeb;padding-bottom:15px}[data-v-f1f952fc] .el-drawer__header{border-bottom:1px solid #ebebeb;padding:10px 20px;margin-bottom:0}.buildDetail[data-v-f1f952fc] .el-dialog__body,[data-v-f1f952fc] .el-drawer__body{padding:0}.btnClass[data-v-f1f952fc]{display:flow-root;height:50px;line-height:50px;padding:0 15px}", ""]);
// Exports
module.exports = exports;
